import React from "react";
// Shared layouts
import DashboardLayout from "layouts/Dashboard";
import theme from "../../theme";
import { GraphApdex } from "./components/GraphApdex";

function Apdex() {
  return (
    <DashboardLayout
      title="Apdex"
      callbackFromParent={() => {}}
      isFirstTime={true}
    >
      <div style={{ padding: theme.spacing(3) }}>
        <GraphApdex />
      </div>
    </DashboardLayout>
  );
}

export { Apdex };
